import {
  ActionReducerMap
} from '@ngrx/store';
import * as fromRoot from 'src/app/store';
import * as Actions from './actions/classification-search.actions';
import * as Selectors from './selectors/classification-search.selectors';
import * as State from './reducers/classification-search.state';
import * as Reducer from './reducers/classification-search.reducer';
import * as Effects from './effects/classification-search.effects';
import * as Model from './models/classification';

export const reducers: ActionReducerMap<State.State> = {
  appstate: fromRoot.Reducer.reducer,
  classificationsearchstate: Reducer.reducer
};

export {
  Actions,
  Selectors,
  State,
  Effects,
  Reducer,
  Model
};
